import React from "react";
import CustomField from "../../buildingBlocks/CustomField";
import ValueUnit from "../../buildingBlocks/ValueUnit";
import ValueError from "../../buildingBlocks/ValueError";
import ArrayField from "../../buildingBlocks/ArrayField";
import EntityInvolved from "./EntityInvolved";
import FormWrapper from "../../buildingBlocks/FormWrapper";
import UseDefault from "../../buildingBlocks/UseDefault";
import OptionalField from "../../buildingBlocks/OptionalField";
import CreateUuid from "../../buildingBlocks/CreateUuid";

function HalfMaximalEffectiveConcentrationEC50({ name }) {
  CreateUuid(name);

  const tooltips = {
    entityInvolved:
      "List of chemical or molecular assemblies the result describes and how many copies of each are involved",
  };

  const unitOptions = [
    { value: "M", label: "M" },
    { value: "mM", label: "mM" },
    { value: "µM", label: "µM" },
    { value: "nM", label: "nM" },
    { value: "pM", label: "pM" },
    { value: "fM", label: "fM" },
    { value: "aM", label: "aM" },
    { value: "g/L", label: "g/L" },
    { value: "mg/mL", label: "mg/mL" },
    { value: "µg/mL", label: "µg/mL" },
    { value: "ng/mL", label: "ng/mL" },
    { value: "mol/kg", label: "mol/kg" },
    { value: "mmol/kg", label: "mmol/kg" },
    { value: "v/v %", label: "v/v %" },
    { value: "w/w %", label: "w/w %" },
    { value: "v/w %", label: "v/w %" },
    { value: "w/v %", label: "w/v %" },
    { value: "U/ml", label: "U/ml" },
    { value: "% saturated", label: "% saturated" },
  ];

  const fieldNameEntityInvolved = "entities_involved";
  UseDefault(`${name}.${fieldNameEntityInvolved}`, [{}]);

  return (
    <>
      <div className="flex mb-3">
        <div className="mr-3">
          <CustomField
            name={name}
            required
            fieldName="name"
            label="Name"
            tooltip="Descriptive name (id) of the result (e.g. Kd of Lysozyme and VHH2). Must be unique within a record"
          />
        </div>

        <ValueUnit
          options={unitOptions}
          name={name}
          valueRequired
          unitRequired
          tooltipValue="Numerical value of the result"
          tooltipUnit="Unit of the half maximal effective concentration"
        />
      </div>

      <OptionalField
        name={name}
        label="Value error"
        fieldName="value_error"
        tooltip="The expected error of the result in terms of a 95 % confidence interval"
        renderChild={({ optionalFieldName }) => (
          <ValueError name={optionalFieldName} colorSchema="light" />
        )}
      />

      <ArrayField
        name={name}
        label="Entity involved"
        fieldName={fieldNameEntityInvolved}
        required
        tooltip={tooltips.entityInvolved}
        renderChild={({ arrayName, index }) => (
          <FormWrapper
            colorSchema="light"
            headline={`Entity involved ${index + 1}`}
            tooltip={tooltips.entityInvolved}
            name={arrayName}
          >
            <EntityInvolved name={`${arrayName}.${index}`} />
          </FormWrapper>
        )}
      />
    </>
  );
}

export default HalfMaximalEffectiveConcentrationEC50;
